export default "__VITE_ASSET__ROYCZ5Gr__"